import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useSourceContext } from "@/pages/import/SourcesPage/SourcePage";

const SourceDetails = () => {
  const { source } = useSourceContext();

  const vendorLabels: Record<string, string> = {
    postgres: "Postgres",
    redshift: "Redshift",
    redshift_serverless: "Redshift Serverless",
    bigquery: "BigQuery",
    snowflake: "Snowflake",
    s3: "S3",
    abs: "Azure Blob Storage",
    sftp: "SFTP",
    gcs: "Google Cloud Storage",
    s3_compatible: "S3 Compatible",
    delta_sharing: "Delta Sharing",
  };
  const sourceType = vendorLabels[source.vendor] ?? "Unknown";

  const conn =
    source.vendor === "postgres"
      ? source.postgres
      : source.vendor === "redshift"
        ? source.redshift
        : source.vendor === "redshift_serverless"
          ? source.redshift_serverless
          : null;

  const username =
    source.vendor === "postgres"
      ? source.postgres.password_auth.username
      : conn && "username" in conn
        ? conn.username
        : undefined;

  return (
    <>
      <div className="space-y-1">
        <h3 className="text-lg/6 font-medium text-gray-900">Details</h3>
      </div>
      <div className="mt-6">
        <DescriptionList>
          <DescriptionList.Item label="ID" value={source.id} />
          <DescriptionList.Item label="Name" value={source.name} />
          <DescriptionList.Item label="Provider ID" value={source.provider_id} />
          <DescriptionList.Item label="Type" value={sourceType} />

          {conn && (
            <>
              <DescriptionList.Item label="Host" value={conn.host} />
              <DescriptionList.Item label="Port" value={conn.port} />
              <DescriptionList.Item label="Database" value={conn.database} />
              {!!username && <DescriptionList.Item label="Username" value={username} />}
              <DescriptionList.Item label="SSL Disabled" value={conn.disable_ssl ? "Yes" : "No"} />
              <DescriptionList.Item label="SSH Tunnel" value={conn.use_ssh_tunnel ? "Yes" : "No"} />
            </>
          )}

          {source.vendor === "redshift" && (
            <>
              {source.redshift.cluster && <DescriptionList.Item label="Cluster" value={source.redshift.cluster} />}
              {source.redshift.region && <DescriptionList.Item label="Region" value={source.redshift.region} />}
            </>
          )}

          {source.vendor === "redshift_serverless" && (
            <>
              {source.redshift_serverless.region && (
                <DescriptionList.Item label="Region" value={source.redshift_serverless.region} />
              )}
              {source.redshift_serverless.workgroup && (
                <DescriptionList.Item label="Workgroup" value={source.redshift_serverless.workgroup} />
              )}
            </>
          )}

          {source.vendor === "bigquery" && (
            <>
              <DescriptionList.Item label="Project ID" value={source.bigquery.project_id} />
              <DescriptionList.Item label="Region" value={source.bigquery.region} />
            </>
          )}

          {source.vendor === "snowflake" && (
            <>
              <DescriptionList.Item label="Host" value={source.snowflake.host} />
              <DescriptionList.Item label="Port" value={source.snowflake.port} />
              <DescriptionList.Item label="Database" value={source.snowflake.database} />
              {source.snowflake.username && <DescriptionList.Item label="Username" value={source.snowflake.username} />}
              <DescriptionList.Item label="Auth Method" value={source.snowflake.auth_method} />
            </>
          )}

          <DescriptionList.Item label="Created" value={<Timestamp timestamp={source.created_at} />} />
          <DescriptionList.Item label="Updated" value={<Timestamp timestamp={source.updated_at} />} />
        </DescriptionList>
      </div>
    </>
  );
};

export default SourceDetails;
